<template>
  <div class="app-container">
    <el-form :inline="true" :model="queryParams" class="demo-form-inline">
      <el-form-item label="租户">
        <el-select v-model="queryParams.tenantId" placeholder="请选择租户" clearable style="width: 200px">
          <el-option v-for="tenant in tenantList" :key="tenant.tenantId" :label="tenant.name" :value="tenant.tenantId" />
        </el-select>
      </el-form-item>
      <el-form-item label="日期范围">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item label="排序方式">
        <el-select v-model="queryParams.sortBy" placeholder="请选择">
          <el-option label="评分" value="rating" />
          <el-option label="会话数" value="conversations" />
          <el-option label="响应时间" value="responseTime" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadData">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="rankingList" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="排名" type="index" align="center" width="80" />
      <el-table-column label="客服名称" prop="agentName" align="center" />
      <el-table-column label="会话数" prop="conversationCount" align="center" width="120" />
      <el-table-column label="平均评分" prop="avgRating" align="center" width="120">
        <template slot-scope="{row}">
          <el-rate v-model="row.avgRating" disabled show-score text-color="#ff9900" />
        </template>
      </el-table-column>
      <el-table-column label="平均响应时间" prop="avgResponseTime" align="center" width="140">
        <template slot-scope="{row}">
          <span>{{ row.avgResponseTime }} s</span>
        </template>
      </el-table-column>
      <el-table-column label="满意度" prop="satisfactionRate" align="center" width="120">
        <template slot-scope="{row}">
          <span>{{ (row.satisfactionRate * 100).toFixed(2) }}%</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getAgentRanking } from '@/api/statistics'
import { listTenants } from '@/api/tenant'

export default {
  name: 'StatisticsAgent',
  data() {
    return {
      queryParams: {
        tenantId: undefined,
        sortBy: 'rating'
      },
      dateRange: [],
      rankingList: [],
      tenantList: [],
      loading: false
    }
  },
  mounted() {
    this.getTenantList()
    this.initDateRange()
  },
  methods: {
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records || []
      })
    },
    initDateRange() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.dateRange = [start, end]
    },
    async loadData() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning('请选择日期范围')
        return
      }
      
      const startDate = this.formatDate(this.dateRange[0])
      const endDate = this.formatDate(this.dateRange[1])
      
      this.loading = true
      try {
        const res = await getAgentRanking({
          tenantId: this.queryParams.tenantId,
          startDate,
          endDate,
          sortBy: this.queryParams.sortBy
        })
        this.rankingList = res.data || []
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
</style>
